import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseNoticeDetailInfo.module.scss'

const cx = className.bind(style)

const MyhouseNoticeDetailInfo: React.FC = () => {
  return <p className={cx('myhouse_detail_info')}>단지 입주민에게만 보이는 게시글입니다.</p>
}

export default MyhouseNoticeDetailInfo
